enum TextSize {
  SMALL = '2',
  MEDIUM = '4',
  LARGE = '6',
}

export default TextSize;
